/**
 * File: useAffiliatesQueries.ts
 * Path: apps/admin/src/shared/hooks/useAffiliatesQueries.ts
 * Description: The referral partners, for choosing who sent a lead. Read
 * through the same admin function the Referrals page uses, and only when
 * asked (enabled), because it is one call per page view.
 */

import { useQuery } from "@tanstack/react-query";
import { FunctionsService } from "@idk/config";
import type { Affiliate } from "@idk/types";

export const useAffiliates = (enabled: boolean) =>
  useQuery({
    queryKey: ["affiliates", "list"],
    enabled,
    staleTime: 60_000,
    queryFn: async (): Promise<Affiliate[]> => {
      const res = await FunctionsService.call<undefined, { items: Affiliate[] }>("listAffiliates");
      return res.items ?? [];
    },
  });
